import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { Building2 } from "lucide-react";

export default function Facilities() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/facilities?limit=50").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);
  return (
    <div data-testid="facilities-page">
      <PageHero eyebrow="Fasilitas" title="Fasilitas Sekolah" subtitle="Ruang-ruang pembelajaran, laboratorium, perpustakaan, dan fasilitas olahraga yang mendukung tumbuh-kembang murid." image="https://images.pexels.com/photos/35551010/pexels-photo-35551010.jpeg?auto=compress&cs=tinysrgb&w=2000" />
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((f) => (
            <div key={f.id} data-testid={`facility-${f.id}`} className="card-elevated overflow-hidden">
              <div className="aspect-video overflow-hidden"><img src={f.image_url} alt={f.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" /></div>
              <div className="p-6">
                <Building2 className="w-6 h-6 text-amber-600" />
                <div className="font-serif font-bold text-lg text-[#0B1D3A] mt-3">{f.name}</div>
                <p className="mt-2 text-sm text-slate-600">{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
